/* Cart drawer behaviour, split out of snippets/cart-panel.liquid so it is
   cached instead of re-parsed inline on every page.

   Liquid-dependent values are handed over on window by the snippet before this
   loads: window.KM_CART_PREFS and window.KM_CART_LABELS. */
(function () {
  /* These four were lost when the JS was first extracted — the slice that
     lifted the body out started below them, so every function here referenced
     an undeclared `root` and the whole file threw ReferenceError on load. The
     drawer markup rendered and nothing was ever bound to it. */
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var CURRENCY = root.getAttribute('data-currency') || 'USD';
  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 0;

  var KM_PREFS = window.KM_CART_PREFS || {};
  var KM_LABELS = window.KM_CART_LABELS || {};
  function kmPref(k, d) { var v = KM_PREFS[k]; return v === undefined || v === null || v === '' ? d : v; }

  /* ── Escaping ─────────────────────────────────────────────────────────────
     Every string below is drawn from /cart.js: product titles, variant titles,
     line-item property KEYS and VALUES (the customer's own engraving text),
     uploaded filenames and URLs. All of it is echoed back into innerHTML, so all
     of it is escaped first — same discipline as showError(), which puts the
     server's message in with textContent.
     Two things go wrong without this on a store selling final-sale engraved
     goods: "Amy <love> Ben" is swallowed by the parser, so the customer cannot
     proof-read the text about to be cut into a non-returnable piece; and
     "<img src=x onerror=...>" runs as script. */
  function escapeHtml(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* Escaping alone does not make a URL safe to put in href/src — "javascript:…"
     survives it untouched. Only http(s), protocol-relative (the Shopify CDN can
     still hand back "//cdn.shopify.com/…" for a line-item image) and relative paths
     are allowed through; anything else comes back '' and the caller falls back to
     plain text instead of a link. */
  function safeUrl(u) {
    var s = String(u === null || u === undefined ? '' : u).replace(/^[\s\u0000-\u001f]+|[\s\u0000-\u001f]+$/g, '');
    if (!s) return '';
    // whitespace + control chars dropped for the SCHEME test only, so that
    // "java\tscript:alert(1)" cannot sneak past the check
    var probe = s.replace(/[\s\u0000-\u001f]/g, '').toLowerCase();
    if (/^https?:\/\//.test(probe)) return s;          // absolute http(s)
    if (probe.indexOf('//') === 0) return s;           // protocol-relative (CDN)
    if (s.charAt(0) === '/') return s;                 // root-relative path
    if (probe.indexOf(':') === -1) return s;           // relative path, no scheme
    return '';                                         // javascript:, data:, vbscript:, …
  }

  /* ── Money ────────────────────────────────────────────────────────────────
     Formatted from the Liquid-rendered samples on the drawer root, NOT from the
     browser: Intl.NumberFormat(undefined, {currency:'USD'}) uses the VISITOR's
     locale, so an en-GB shopper read "US$34.00" in the bag next to "$34.00"
     everywhere else on the page. data-money-sample is money(100) and
     data-money-grouped is money(123456789); between them they give the symbol,
     its placement, the decimal separator, the decimal count and the thousands
     separator, whatever the shop's money format happens to be. */
  var MONEY = (function () {
    var sample = (root.getAttribute('data-money-sample') || '').replace(/^\s+|\s+$/g, '');
    var parts = sample.match(/^(\D*)(.*\d)(\D*)$/);
    if (!parts) return null;
    var core = parts[2];                                // "1.00" / "1,00" / "1"
    var dec = core.match(/(\D)(\d+)$/);                 // trailing decimal group
    var decSep = dec ? dec[1] : '';
    var decimals = dec ? dec[2].length : 0;

    var grouped = (root.getAttribute('data-money-grouped') || '').replace(/^\s+|\s+$/g, '');
    var gparts = grouped.match(/^(\D*)(.*\d)(\D*)$/);
    var whole = gparts ? gparts[2] : '';                // "1,234,567.89"
    if (decimals && decSep) {
      var cut = whole.lastIndexOf(decSep);
      if (cut > -1) whole = whole.slice(0, cut);        // "1,234,567"
    }
    var group = '';
    for (var i = 0; i < whole.length; i++) {
      var ch = whole.charAt(i);
      if (ch < '0' || ch > '9') { group = ch; break; }
    }
    return {
      prefix: parts[1],
      suffix: parts[3],
      decSep: decSep,
      decimals: decimals,
      group: group,
      groupRepl: group.replace(/\$/g, '$$$$')           // $ is special in String#replace
    };
  })();

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0;
    if (neg) n = -n;
    // Samples missing (markup changed?) — print the ISO code rather than guess a
    // symbol, so the number is never labelled with the wrong currency.
    if (!MONEY) return (neg ? '-' : '') + (n / 100).toFixed(2) + ' ' + CURRENCY;
    var bits = (n / 100).toFixed(MONEY.decimals).split('.');
    var whole = bits[0];
    if (MONEY.group) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.groupRepl);
    var body = bits[1] ? whole + MONEY.decSep + bits[1] : whole;
    return (neg ? '-' : '') + MONEY.prefix + body + MONEY.suffix;
  }

  var els = {
    items: root.querySelector('[data-cd-items]'),
    empty: root.querySelector('[data-cd-empty]'),
    foot: root.querySelector('[data-cd-foot]'),
    subtotal: root.querySelector('[data-cd-subtotal]'),
    savings: root.querySelector('[data-cd-savings]'),
    count: root.querySelector('[data-cd-count]'),
    ship: root.querySelector('[data-cd-ship]'),
    earnedList: root.querySelector('[data-cd-earned-list]'),
    shipMsg: root.querySelector('[data-cd-ship-msg]'),
    shipFill: root.querySelector('[data-cd-ship-fill]'),
    upsell: root.querySelector('[data-cd-upsell]'),
    gift: root.querySelector('[data-cd-gift]'),
    error: root.querySelector('[data-cd-error]')
  };

  /* --- Top layer -----------------------------------------------------------
     z-index is a contest the theme cannot win: apps choose their own numbers,
     and the countdown bar on this store already sits above where the drawer
     used to. The top layer is a different painting surface altogether, above
     every z-index in the document. What can still cover us is another top-layer
     element - an app's dialog, or one of this theme's own showModal() viewers -
     so the honest guarantee is that no z-index can reach us, not that nothing
     can.

     The attribute is set from JS, never in the Liquid. A browser without
     support simply never receives it and keeps the z-index path above, so there
     is no route by which an unsupported feature leaves the bag unreachable. */
  var CAN_TOP = typeof HTMLElement !== 'undefined' &&
                Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover');
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var EXIT_MS = REDUCED ? 0 : 250;   /* tracks --duration-normal (base.css:74) */
  var hideTimer = null;

  if (CAN_TOP) { try { root.setAttribute('popover', 'manual'); } catch (e) { CAN_TOP = false; } }

  function topShow() {
    if (!CAN_TOP) return;
    clearTimeout(hideTimer); hideTimer = null;
    /* open() is legitimately re-entered - the upsell "+" routes through
       addVariant, which opens again - and showPopover() throws if already
       showing. */
    try { if (!root.matches(':popover-open')) root.showPopover(); } catch (e) {}
  }

  function topHide() {
    if (!CAN_TOP) return;
    clearTimeout(hideTimer);
    /* Leave the top layer only after the slide-out, so the exit plays above app
       widgets exactly as the entrance did. Dropping out first would demote the
       drawer to its fallback z-index for the whole 250ms of the animation. */
    hideTimer = setTimeout(function () {
      hideTimer = null;
      if (root.classList.contains('is-open')) return;      /* reopened mid-wait */
      try { if (root.matches(':popover-open')) root.hidePopover(); } catch (e) {}
    }, EXIT_MS);
  }

  /* --- Back closes the bag, it does not leave the store -------------------
     On a phone, Back is THE dismiss gesture for a sheet. The drawer put
     nothing on the history stack, so Back skipped it and exited the site
     entirely - and for social traffic that means back into the Instagram or
     TikTok browser, cart and all. One entry is pushed on open and popped on
     close, which makes the gesture mean what everyone already expects.

     The pair cannot loop: whichever side runs first clears histPushed, so the
     other becomes a no-op. pushState carries no URL, so the entry is a
     duplicate of the current page and normal navigation is unaffected. */
  var histPushed = false;
  function pushHist() {
    try { if (!histPushed) { history.pushState({ kmBag: 1 }, ''); histPushed = true; } } catch (e) {}
  }
  function popHist() {
    try {
      if (!histPushed) return;
      histPushed = false;
      /* Only unwind OUR entry. If anything else pushed state while the bag was
         open, going back would undo that instead - the collection page's filter
         state being the one that exists on this store. */
      if (history.state && history.state.kmBag) history.back();
    } catch (e) {}
  }
  window.addEventListener('popstate', function () {
    histPushed = false;
    if (root.classList.contains('is-open')) close();
  });

  function open() {
    pushHist();
    topShow();
    void root.offsetWidth;             /* commit the pre-open frame so it slides rather than jumps */
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    clearError();
    /* Flush any half-typed note before the drawer goes away — the debounce
       would otherwise still be pending and the text lost. */
    if (typeof saveNote === 'function') { clearTimeout(noteTimer); saveNote(); }
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    topHide();
    popHist();
  }
  /* Checkout is disabled for the whole write, not just styled as busy.
     pointer-events alone still leaves the button reachable by keyboard, and
     the window between a quantity tap and its re-render is exactly where a
     second impatient tap lands - which would send someone to checkout with
     the total they were in the middle of changing. The attribute also stops
     the click handler ever running, so the reward-only guard cannot be raced
     either. */
  function setLoading(on) {
    root.classList.toggle('is-loading', !!on);
    var btn = root.querySelector('[data-cd-checkout]');
    if (btn) {
      btn.disabled = !!on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
  }

  /* .cd-item.is-updating sets opacity .45 and pointer-events none. It is
     normally cleared by render() rebuilding the list, so a write that fails
     AND whose recovery refresh also fails would otherwise leave the row dead
     for the rest of the session. */
  function unlockRows() {
    try {
      root.querySelectorAll('.cd-item.is-updating').forEach(function (el) {
        el.classList.remove('is-updating');
      });
    } catch (e) {}
  }

  /* ── Cart error surface ───────────────────────────────────────────────────
     /cart/add.js answers a rejected add with HTTP 422 and a JSON body, e.g.
     {"status":422,"description":"Cannot find variant"}. That body parses fine,
     so a bare .then(r => r.json()) walks a FAILURE straight down the success
     path and the bag slides open showing the old contents — which the customer
     reads as "it worked". Every cart write goes through cartJson() instead. */
  var GENERIC_CART_ERROR = 'Sorry — we couldn’t add that to your bag. Please try again.';

  function cartError(msg) {
    var text = msg || GENERIC_CART_ERROR;
    var err = new Error(text);
    err.cartMessage = text;   // tags it as OUR message, so raw JS errors never reach the shopper
    return err;
  }
  function messageFor(err) { return (err && err.cartMessage) || GENERIC_CART_ERROR; }

  // Same r.ok idiom as sections/main-product.liquid, but it also carries
  // Shopify's own `description` out — that copy is written for the customer
  // ("All 1 Forever Necklace are in your cart"), so it beats anything generic.
  function cartJson(r) {
    if (r.ok) return r.json();
    return r.json().catch(function () { return null; }).then(function (data) {
      throw cartError(data && (data.description || data.message));
    });
  }

  function clearError() {
    if (!els.error) return;
    els.error.textContent = '';        // back to :empty — collapsed, nothing focusable
    els.error.classList.remove('is-flash');
  }

  function showError(msg) {
    if (!els.error) return;
    els.error.innerHTML =
      '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false">' +
        '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.4v.2"/>' +
      '</svg><span class="cart-drawer__error-text"></span>';
    // textContent, never innerHTML — the string came off the wire.
    els.error.querySelector('.cart-drawer__error-text').textContent = msg || GENERIC_CART_ERROR;
    els.error.classList.remove('is-flash');
    void els.error.offsetWidth;        // reflow so the attention flash replays on a repeat failure
    els.error.classList.add('is-flash');
  }

  function clearSkeletons() {
    var rows = els.items.querySelectorAll('.cd-skel');
    for (var i = 0; i < rows.length; i++) { rows[i].parentNode.removeChild(rows[i]); }
  }
  function skeletonRows(n) {
    var s = '';
    for (var i = 0; i < n; i++) { s += '<div class="cd-skel"><div class="cd-skel__img"></div><div class="cd-skel__lines"><span></span><span></span></div></div>'; }
    return s;
  }

  function setHeaderCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-empty', n === 0);
    });
    if (els.count) els.count.textContent = n;
  }

  /* 'Free gift' used to be written onto the line as a visible property, so a
     warranty that did NOT qualify still carried the words Free gift through
     to checkout while charging $6.95 for it. The label is hidden now and
     shown here only when the line really is free. */
  function giftBadge(it) {
    var label = it.properties && it.properties._km_gift_label;
    if (!label || it.final_line_price !== 0) return '';
    return '<p class="cd-item__gift">' + escapeHtml(String(label)) + '</p>';
  }

  function renderProps(props) {
    if (!props) return '';
    // per-field prices from the personalizer: "Name 2=>+$2.00||Font=>+$2.00"
    var prices = {};
    String(props._km_prices || '').split('||').forEach(function (pair) {
      var i = pair.indexOf('=>');
      if (i > 0) prices[pair.slice(0, i)] = pair.slice(i + 2);
    });
    var keys = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k]; });
    if (!keys.length) return '';
    var sep = kmPref('cart_price_separator', '|');
    var thumbSize = parseInt(kmPref('cart_thumb_size', 44), 10) || 44;
    return '<ul class="cd-item__props">' + keys.map(function (k) {
      var v = String(props[k]);
      var thumb = '';
      // The engraving text is the whole point of the row — it goes in escaped and
      // VERBATIM, so "Amy <love> Ben" reads back exactly as it will be engraved.
      var value = escapeHtml(v);
      if (v.indexOf('/uploads/') !== -1) {
        var href = safeUrl(v);
        if (href) {
          if (kmPref('cart_thumbs', true) !== false && /\.(png|jpe?g|gif|webp|avif)(\?|$)/i.test(v)) {
            thumb = '<img class="cd-item__prop-img" style="width:' + thumbSize + 'px;height:' + thumbSize + 'px" src="' + escapeHtml(href) + '" alt="" loading="lazy">';
          }
          value = '<a href="' + escapeHtml(href) + '" target="_blank" rel="noopener">' + escapeHtml(KM_LABELS.view_upload || 'View uploaded file') + '</a>';
        }
        // an unsafe URL keeps the escaped plain-text branch above — still readable
      }
      var price = '';
      if (kmPref('cart_prices', true) !== false && prices[k]) {
        price = ' <span class="cd-item__prop-price">' + (sep ? escapeHtml(sep) + ' ' : '') + escapeHtml(prices[k]) + '</span>';
      }
      return '<li class="cd-item__prop"><b>' + escapeHtml(k) + ':</b> ' + value + price + thumb + '</li>';
    }).join('') + '</ul>';
  }

  function editLink(it) {
    if (kmPref('edit_drawer', true) === false) return '';
    if (!it.properties || !it.properties._km_key) return '';
    var base = safeUrl(it.url);
    if (!base) return '';
    var href = base + (base.indexOf('?') !== -1 ? '&' : '?') + 'km_edit=' + encodeURIComponent(it.key);
    return '<a class="cd-item__edit" href="' + escapeHtml(href) + '">' + escapeHtml(kmPref('edit_link_text', 'Edit personalization')) + '</a>';
  }

  /* A line that has been discounted must say so. Shopify puts store-wide and
     automatic discounts (a BOGO, for instance) in line_level_discount_allocations,
     NOT in cart_level_discount_applications — so a cart-level-only reading shows
     an item priced at 20.00 beside an identical one at 39.99 with nothing to
     explain it, which reads as a bug in the shop. */
  /* The two shipping messages are merchant-editable, so they arrive as plain
     text and are escaped before anything else - nothing typed into a theme
     setting should be able to inject markup. Only two things are then granted
     back: [amount], which carries the money value, and *emphasis*, which is how
     the merchant keeps the accent colour on the words that matter without
     being handed an HTML field. */
  var shipEl = root.querySelector('[data-cd-ship]');
  var SHIP_PROGRESS = shipEl ? (shipEl.getAttribute('data-progress') || '') : '';
  var SHIP_UNLOCKED = shipEl ? (shipEl.getAttribute('data-unlocked') || '') : '';
  var TIER_NEXT = shipEl ? (shipEl.getAttribute('data-tier-next') || '') : '';
  var TIER_ALL = shipEl ? (shipEl.getAttribute('data-tier-all') || '') : '';
  var upsellSig = null;                     /* last in-bag set, to avoid churn */
  var shipWasMet = null;                    /* null = first render, never celebrates */
  var tierWasMet = {};                      /* per tier, for the one-time sweep */
  var earnedSig = null;                     /* last list written, to leave it alone */

  /* The configured tiers, lowest first. Free shipping is the marker at zero:
     shipping here is free with no minimum, so it is met as soon as there is
     anything in the bag. That is deliberate - the bar opens already having
     given something, and what it shows is the next thing to reach.

     Reading stops at the first gap, so a tier left blank in the editor is
     simply absent rather than a hole in the middle of the track. */
  var TIERS = (function () {
    if (!shipEl) return [];
    var list = [{
      amount: 0,
      label: shipEl.getAttribute('data-tier-base-label') || '',
      icon: shipEl.getAttribute('data-tier-base-icon') || 'dot',
      img: shipEl.getAttribute('data-tier-base-img') || ''
    }];
    for (var i = 1; i <= 3; i++) {
      var amt = parseInt(shipEl.getAttribute('data-tier-' + i), 10);
      var lab = shipEl.getAttribute('data-tier-' + i + '-label');
      if (!amt || amt <= 0 || !lab) break;
      list.push({
        amount: amt,
        label: lab,
        icon: shipEl.getAttribute('data-tier-' + i + '-icon') || 'dot',
        mode: shipEl.getAttribute('data-tier-' + i + '-mode') || 'spend',
        /* Each entry is a product id, or a gid the theme could not resolve
           ('gid://shopify/Product/123'). The trailing number is the id in
           both shapes, so take that and stop caring which arrived. */
        ids: (shipEl.getAttribute('data-tier-' + i + '-ids') || '')
          .split(',').filter(Boolean).map(function (s) {
            return parseInt(String(s).split('/').pop(), 10);
          }).filter(function (n) { return !isNaN(n); }),
        img: shipEl.getAttribute('data-tier-' + i + '-img') || ''
      });
    }
    while (list.length > 1) {
      var tail = list[list.length - 1];
      if (tail.mode === 'items' && !tail.ids.length) list.pop();   // see ITEMS_MODE
      else break;
    }
    return list.length > 1 ? list : [];
  })();
  var TIER_MAX = TIERS.length ? TIERS[TIERS.length - 1].amount : 0;

  /* The rail is a single axis and the last tier decides its unit. Buy 1 Get
     1 is not a sum of money - it fires on two eligible necklaces and ignores
     everything else in the bag - so a money bar could only ever approximate
     it, and would have promised the discount to a $90 cart that was never
     going to receive it. In items mode the axis counts qualifying units.
     The first marker sits at 0 either way, so free shipping is unaffected. */
  var LAST_TIER = TIERS.length ? TIERS[TIERS.length - 1] : null;
  /* Items mode needs to know WHICH products count. With no list the bar
     cannot tell a qualifying cart from any other, and a bar that counts
     everything would promise the discount to two of anything. Treated as
     unconfigured instead, so the rail quietly falls back to its first
     marker rather than making an offer the discount will not honour. */
  var ITEMS_MODE = !!(LAST_TIER && LAST_TIER.mode === 'items' && LAST_TIER.ids.length);

  function railValue(cart) {
    /* Money: list price, before discounts - the BOGO must not be able to
       push a cart back down the rail it just climbed. */
    if (!ITEMS_MODE) return cart.original_total_price || cart.total_price || 0;
    var ids = LAST_TIER.ids, n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (ids.indexOf(it.product_id) !== -1) n += it.quantity || 0;
    }
    return n;
  }

  /* Markers are written once. Re-rendering them on every cart change would
     restart their transitions, so only the met/unmet classes move after this. */
  var tierNodes = (function () {
    if (!TIERS.length || !shipEl) return [];
    var dots = shipEl.querySelector('[data-cd-tier-dots]');
    var labels = shipEl.querySelector('[data-cd-tier-labels]');
    /* The names row is optional, so a missing container must not take the
       markers with it - they are the part that cannot be done without. */
    if (!dots) return [];
    return TIERS.map(function (tier, i) {
      /* A linear first paint. layout() takes over on the first render, and
         the markers ease from here to where it puts them. */
      var pct = TIER_MAX > 0 ? (tier.amount / TIER_MAX) * 100 : 0;
      var dot = document.createElement('span');
      dot.className = 'cart-drawer__tier-dot';
      dot.style.setProperty('--i', i);
      dot.style.left = pct + '%';
      /* A marker showing what the reward IS carries its own meaning, so it
         keeps the glyph when cleared and inverts instead of swapping to a
         tick - the tick is for markers that have nothing else to show. */
      if (tier.img) {
        var im = document.createElement('img');
        im.className = 'cart-drawer__tier-img';
        im.src = tier.img;
        im.alt = '';
        im.setAttribute('aria-hidden', 'true');
        /* A merchant can delete the image after picking it. Rather than leave
           a hole on the rail, the marker drops back to being a dot. */
        im.onerror = function () {
          dot.classList.remove('has-art', 'has-photo');
          if (im.parentNode) im.parentNode.removeChild(im);
        };
        dot.appendChild(im);
        dot.classList.add('has-art', 'has-photo');
      } else if (tier.icon && tier.icon !== 'dot' && window.KMCartTiers && window.KMCartTiers.icon) {
        var svg = window.KMCartTiers.icon(tier.icon);
        if (svg) { dot.innerHTML = svg; dot.classList.add('has-art'); }
      }
      dots.appendChild(dot);

      var lab = document.createElement('span');
      lab.className = 'cart-drawer__tier-label';
      lab.style.setProperty('--i', i);
      /* The end markers would hang off the rail if every label centred on its
         dot, so the first anchors to its left edge and the last to its right. */
      lab.setAttribute('data-anchor', i === 0 ? 'start' : (i === TIERS.length - 1 ? 'end' : 'mid'));
      lab.textContent = tier.label;
      if (labels) labels.appendChild(lab);
      return { dot: dot, label: lab, tier: tier };
    });
  })();


  /* The names of what has been earned, under the rail.

     Rewritten only when the set actually changes - rebuilding a row on every
     quantity tick is work for nothing, and it would restart the transitions
     on names that have not moved. */
  function renderEarned(total) {
    var list = els.earnedList;
    if (!list) return;
    if (!TIERS.length) { list.hidden = true; return; }

    var won = [];
    for (var i = 0; i < TIERS.length; i++) {
      if (total >= TIERS[i].amount && TIERS[i].label) won.push(TIERS[i].label);
    }
    var sig = JSON.stringify(won);
    if (sig === earnedSig) return;
    earnedSig = sig;

    /* Nothing earned yet, or everything earned: either way this row has
       nothing to add. Once the last tier clears, the message above already
       says so - "included free" and then a tick list repeating the same two
       names is the same sentence twice, in a panel that is pinned above the
       bag and costs its height on every screen. It earns its place only
       while something is still ahead, where it says what is already banked
       and the message says what is next. */
    list.hidden = won.length === 0 || won.length === TIERS.length;
    list.innerHTML = '';
    for (var w = 0; w < won.length; w++) {
      var li = document.createElement('li');
      li.className = 'cart-drawer__earned-item';
      li.textContent = won[w];
      list.appendChild(li);
    }
  }

  function shipText(tpl, amount, reward) {
    var out = escapeHtml(tpl);
    out = out.replace(/\[amount\]/g, amount == null ? '' : escapeHtml(amount));
    out = out.replace(/\[reward\]/g, reward == null ? '' : escapeHtml(reward));
    return out.replace(/\*([^*]+)\*/g, '<b>$1</b>');
  }

  function lineDiscounts(it) {
    var out = [];
    (it.line_level_discount_allocations || it.discounts || []).forEach(function (a) {
      var title = a.discount_application ? a.discount_application.title : a.title;
      var amount = a.amount;
      if (title && amount > 0) out.push({ title: title, amount: amount });
    });
    return out;
  }

  function priceCell(it) {
    var discounted = it.original_line_price > it.final_line_price;
    if (!discounted) {
      return '<span class="cd-item__price">' + escapeHtml(money(it.final_line_price)) + '</span>';
    }
    return '<span class="cd-item__price cd-item__price--cut">' +
             '<s class="cd-item__was">' + escapeHtml(money(it.original_line_price)) + '</s>' +
             '<span class="cd-item__now">' + escapeHtml(money(it.final_line_price)) + '</span>' +
           '</span>';
  }

  function discountTags(it) {
    var ds = lineDiscounts(it);
    if (!ds.length) return '';
    return '<ul class="cd-item__deals">' + ds.map(function (d) {
      return '<li class="cd-item__deal">' + escapeHtml(d.title) +
             ' <b>-' + escapeHtml(money(d.amount)) + '</b></li>';
    }).join('') + '</ul>';
  }

  function render(cart) {
    lastCart = cart;
    setHeaderCount(cart.item_count);
    var isEmpty = cart.item_count === 0;
    if (els.empty) els.empty.hidden = !isEmpty;
    if (els.foot) els.foot.hidden = isEmpty;
    if (els.upsell) els.upsell.hidden = isEmpty;
    if (els.gift) els.gift.hidden = isEmpty;
    renderAddon(cart);
    renderChips(cart);
    holdSync(cart);

    /* innerHTML collapses the list to zero height, which clamps the scroll
       container to 0 - so every quantity tap, remove, promo apply and add-on
       toggle threw the customer back to the top of their own bag. */
    var scrollEl = root.querySelector('.cart-drawer__body');
    var keepScroll = scrollEl ? scrollEl.scrollTop : 0;

    els.items.innerHTML = cart.items.map(function (it, idx) {
      var img = it.image ? safeUrl(String(it.image).replace(/(\.[^.]*)$/, '_160x$1')) : '';
      var url = safeUrl(it.url);
      // no usable URL -> plain <a> with no href: still reads, just isn't a link
      var href = url ? ' href="' + escapeHtml(url) + '"' : '';
      var qty = parseInt(it.quantity, 10) || 0;

      /* The earned reward is not a line anyone edits. A stepper on it offers
         a second free warranty, which is not on offer, and a remove button
         offers to decline something the rail hands straight back on the next
         render - a control that undoes itself is worse than no control. The
         rail gives it and the rail takes it away, so the row just states what
         is in the bag. */
      var isReward = REWARD_VARIANT && it.variant_id === REWARD_VARIANT;

      return '' +
        '<div class="cd-item' + (isReward ? ' cd-item--reward' : '') + '" data-line="' + (idx + 1) + '" data-key="' + escapeHtml(it.key) + '" role="listitem">' +
          (isReward
            ? '<span class="cd-item__media">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</span>'
            : '<a' + href + ' class="cd-item__media">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</a>') +
          '<div class="cd-item__info">' +
            (isReward
              ? '<span class="cd-item__title">' + escapeHtml(it.product_title) + '</span>'
              : '<a' + href + ' class="cd-item__title">' + escapeHtml(it.product_title) + '</a>') +
            (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="cd-item__variant">' + escapeHtml(it.variant_title) + '</p>' : '') +
            renderProps(it.properties) +
            giftBadge(it) +
            discountTags(it) +
            editLink(it) +
            (isReward
              ? ''
              : '<div class="cd-item__bottom">' +
                  '<div class="cd-qty">' +
                    '<button data-cd-minus aria-label="Decrease quantity">−</button>' +
                    '<span class="cd-qty__num">' + qty + '</span>' +
                    '<button data-cd-plus aria-label="Increase quantity">+</button>' +
                  '</div>' + priceCell(it) +
                '</div>') +
          '</div>' +
          (isReward
            ? priceCell(it)
            : '<button class="cd-item__remove" data-cd-remove aria-label="Remove">✕</button>') +
        '</div>';
    }).join('');

    /* Put them back where they were. Restoring synchronously, before the frame
       paints, means the jump is never seen. */
    if (scrollEl && keepScroll) scrollEl.scrollTop = keepScroll;

    if (els.subtotal) els.subtotal.textContent = money(cart.total_price);
    /* The same figure rides on the checkout button, so the number a thumb is
       about to commit to is on the thing it taps. */
    var checkoutTotal = root.querySelector('[data-cd-checkout-total]');
    if (checkoutTotal) checkoutTotal.textContent = money(cart.total_price);
    if (els.savings) {
      var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
      var savedAmt = root.querySelector('[data-cd-savings-amt]');
      if (saved > 0) {
        els.savings.hidden = false;
        if (savedAmt) savedAmt.textContent = '-' + money(saved);
      } else els.savings.hidden = true;
    }

    if (els.ship) {
      els.ship.hidden = isEmpty;
      /* List price, not what is left to pay. The rewards on this rail are
         things the order earns, and the automatic Buy 1 Get 1 takes 50% off
         the second item - so measuring total_price meant the discount that
         fires at two items also pushed the customer back DOWN the rail
         towards the reward two items was supposed to unlock. Two necklaces
         are $89.90 of product and $67.42 to pay; the rail counts the $89.90.
         original_total_price is before every discount, cart and line level. */
      var total = railValue(cart);
      var remain, pct;

      if (TIERS.length && window.KMCartTiers) {
        /* Spacing comes from cart-tiers.js, which the bench drives too, so
           what is tuned there is what runs here - no second copy to drift. */
        var L = window.KMCartTiers.layout(TIERS, total);
        var slotPct = window.KMCartTiers.slots
          ? window.KMCartTiers.slots(L.positions)
          : L.positions.map(function () { return 100 / L.positions.length; });
        pct = L.fillPct;
        var next = L.nextIndex === null ? null : TIERS[L.nextIndex];
        remain = next ? next.amount - total : 0;
        els.shipMsg.innerHTML = next
          ? shipText(TIER_NEXT, ITEMS_MODE ? String(remain) : money(remain), next.label)
          : shipText(TIER_ALL, null, TIERS[TIERS.length - 1].label);

        /* The icon follows the reward being talked about: the next one while
           there is one, the last one once they are all in. Written only when
           it changes, so this is not rebuilding an svg on every quantity tap. */
        if (shipIcon && window.KMCartTiers) {
          var wantIcon = (next || TIERS[TIERS.length - 1]).icon;
          if (wantIcon !== shipIconName) {
            var art = window.KMCartTiers.icon(wantIcon);
            if (art) { shipIcon.innerHTML = art; shipIconName = wantIcon; }
          }
        }

        /* Everything on the rail cleared - hand over the reward. */
        /* A spend reward claims a cents threshold to the cart-transform, and
           on a counted rail there is no such number to claim. */
        if (!ITEMS_MODE) syncReward(cart, next === null);

        for (var n = 0; n < tierNodes.length; n++) {
          var node = tierNodes[n];
          var hit = total >= node.tier.amount;
          node.dot.style.left = L.positions[n] + '%';
          node.label.style.width = slotPct[n] + '%';
          node.dot.classList.toggle('is-met', hit);
          node.label.classList.toggle('is-met', hit);
          /* The next one up is named in the message, so mark it on the rail
             as well - otherwise the sentence and the markers disagree about
             which one is being talked about. */
          node.dot.classList.toggle('is-next', !hit && L.nextIndex === n);
          node.label.classList.toggle('is-next', !hit && L.nextIndex === n);
          if (hit && tierWasMet[n] === false) {
            node.dot.classList.remove('just-hit');
            void node.dot.offsetWidth;
            node.dot.classList.add('just-hit');
          }
          tierWasMet[n] = hit;
        }
      } else {
        /* No tiers configured - or cart-tiers.js did not load - so the
           original single-threshold bar, unchanged.
           Threshold 0 means shipping is free with no minimum, so there is no
           distance to travel - the bar sits full and states the fact rather
           than dividing by zero and rendering NaN%. */
        remain = THRESHOLD > 0 ? THRESHOLD - total : 0;
        pct = THRESHOLD > 0 ? Math.min(100, Math.round((total / THRESHOLD) * 100)) : 100;
        els.shipMsg.innerHTML = remain > 0
          ? shipText(SHIP_PROGRESS, money(remain), null)
          : shipText(SHIP_UNLOCKED, null, null);
      }

      els.shipFill.style.width = pct + '%';
      els.ship.classList.toggle('is-met', remain <= 0);
      els.ship.classList.toggle('has-tiers', TIERS.length > 0);
      renderEarned(total);

      /* Fire the completion sweep on the transition into met, not on every
         render while met - otherwise every quantity change replays a moment
         that already happened and the gesture stops meaning anything. */
      var met = remain <= 0;
      if (met && shipWasMet === false) {
        els.ship.classList.remove('just-met');
        void els.ship.offsetWidth;          /* restart the animation */
        els.ship.classList.add('just-met');
        setTimeout(function () { els.ship.classList.remove('just-met'); }, 1200);
      }
      shipWasMet = met;
    }

    if (els.upsell && !isEmpty) {
      /* Matched on PRODUCT, not variant. The card carries whichever variant
         happened to be first available, so a bag holding Gold / 2 Names did
         not match a card built from Gold / 1 Name, and the row went on
         offering what was already in the bag. */
      var inCart = {};
      cart.items.forEach(function (it) { inCart[it.product_id] = true; });

      /* Demoted rather than hidden. Something already in the bag is still
         worth a second one - that is how the BOGO gets reached - it just has
         no business occupying the first card, where the point is to show
         something new. */
      var fresh = [], seen = [], sig = [];
      root.querySelectorAll('[data-cd-upsell-item]').forEach(function (u) {
        u.style.display = '';
        var pid = parseInt(u.getAttribute('data-product'), 10);
        var held = !!inCart[pid];
        u.classList.toggle('is-in-cart', held);
        (held ? seen : fresh).push(u);
        if (held) sig.push(pid);
      });

      /* Only reorder when the set actually changes: moving nodes on every
         quantity tick would reset the row's scroll under a thumb mid-swipe. */
      var nextSig = sig.sort().join(',');
      if (nextSig !== upsellSig) {
        upsellSig = nextSig;
        var rowEl = fresh[0] ? fresh[0].parentNode : (seen[0] && seen[0].parentNode);
        if (rowEl) {
          fresh.concat(seen).forEach(function (u) { rowEl.appendChild(u); });
          rowEl.scrollLeft = 0;
        }
      }
      els.upsell.hidden = false;
      upsellDots();
    }
  }

  /* cartJson lives above, next to cartError. A second copy sat here and, because
     function declarations hoist, it was the one that ran - so err.cartMessage
     was never set, messageFor() fell through to the generic string for every
     failure, and Shopify's own customer-facing `description` ("All 1 Forever
     Necklace are in your cart") never reached the shopper. The surviving
     version handles /cart.js identically: a non-2xx returns an HTML error page,
     r.json() rejects, the .catch absorbs it, and cartError(null) yields the
     generic message. */
  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(cartJson); }
  function refresh() { return fetchCart().then(render); }

  function addVariant(id, qty) {
    open(); setLoading(true);
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    })
      .then(cartJson)
      .then(function () { clearError(); return refresh(); })   // cleared only once an add really lands
      .catch(function (err) { showError(messageFor(err)); })
      .then(function () { setLoading(false); });
  }

  /* Addressed by line KEY, not by position. The personalizer embed inserts and
     removes gift lines asynchronously (see the cart:refresh listener below), so
     a positional index can be stale by the time the request lands and the tap
     then edits the wrong row. renderAddon already removes by key and proves the
     endpoint accepts it. */
  function changeQty(key, qty) {
    /* Every write marks the cart busy, not just the ones that open the
       drawer. A quantity tap is the most common write there is and the one
       most likely to be followed by an immediate checkout tap, and it was the
       only write that left the button live. */
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    })
      .then(cartJson)
      .then(function (cart) { clearError(); render(cart); })
      .then(function () { setLoading(false); }, function (err) { setLoading(false); throw err; })
      .catch(function (err) {
        showError(messageFor(err));
        /* Release the lock HERE rather than relying on the re-render. If this
           refresh also rejects, the row keeps opacity .45 and pointer-events
           none for the rest of the session - a bag the customer cannot edit
           and cannot recover from. */
        unlockRows();
        return refresh().catch(function () {});
      });
  }

  // Intercept all add-to-cart product forms — open INSTANTLY, then sync
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    clearError();                             // a fresh attempt starts on a clean slate
    open();                                   // instant — no waiting on the network
    setLoading(true);
    if (els.empty) els.empty.hidden = true;
    els.items.insertAdjacentHTML('afterbegin', skeletonRows(1)); // optimistic placeholder
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(cartJson)
      .then(function () { clearError(); return refresh(); })  // refresh re-renders, clearing the skeleton
      .catch(function (err) {
        // The drawer is already open by design (instant-open UX), so it cannot be
        // withheld — make the failure unmistakable instead: kill the optimistic
        // placeholder that reads as "added", repaint the REAL cart, and flash the
        // announced error above the items.
        clearSkeletons();
        showError(messageFor(err));
        return refresh().catch(function () {});
      })
      .then(function () { setLoading(false); if (btn) btn.classList.remove('is-loading'); });
  });

  // Open triggers (header cart icon, etc.) — open INSTANTLY using already-rendered cart, sync in background
  /* Delegated, not bound per node. The cart icon lives inside the header
     section, so a querySelectorAll at load time is orphaned by the next
     shopify:section:load - in the theme editor the icon would quietly stop
     opening the drawer. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-cart-drawer-toggle]');
    if (!toggle) return;
    e.preventDefault();
    open();
    setLoading(true);
    /* Always clear the loading bar, including when the refresh fails —
       an uncaught rejection here left it animating with no way back. */
    refresh()
      .catch(function () {
        showError('We could not load your bag. Please try again.');
        /* els.foot ships hidden from Liquid and is only revealed inside
           render(). If this refresh fails the drawer opens with no items, no
           empty state and NO CHECKOUT BUTTON. Checkout works server-side
           regardless of whether this fetch did, so reveal it. */
        if (els.foot) els.foot.hidden = false;
      })
      .then(function () { setLoading(false); });
  });

  // Delegated controls inside drawer
  root.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-cd-close]'); if (closeBtn) { close(); return; }
    var item = e.target.closest('.cd-item');
    if (item) {
      var line = item.getAttribute('data-key');
      var qtyNum = parseInt(item.querySelector('.cd-qty__num').textContent, 10);
      if (e.target.closest('[data-cd-plus]')) { item.classList.add('is-updating'); changeQty(line, qtyNum + 1); return; }
      if (e.target.closest('[data-cd-minus]')) { item.classList.add('is-updating'); changeQty(line, qtyNum - 1); return; }
      if (e.target.closest('[data-cd-remove]')) { item.classList.add('is-updating'); changeQty(line, 0); return; }
    }
    var addUp = e.target.closest('[data-cd-upsell-add]');
    if (addUp) { addUp.disabled = true; addVariant(parseInt(addUp.getAttribute('data-cd-upsell-add'), 10), 1).then(function(){ addUp.disabled = false; }); return; }
    var checkout = e.target.closest('[data-cd-checkout]');
    if (checkout) {
      if (blockRewardOnly(e)) return;
      /* On 4G in an in-app browser the navigation can take over a second,
         during which nothing on screen changed. A dead-looking button gets
         tapped again, or read as broken. .btn.is-loading already exists in
         base.css and the button already carries .btn. */
      checkout.classList.add('is-loading');
      window.location.href = '/checkout';
      return;
    }
  });

  /* ── Bag-saved countdown ──────────────────────────────────────────────────
     Shopify reserves no stock for a cart, so this never says anything is being
     held back from anyone. It counts how long the bag stays saved — true, since
     the cart cookie outlives the session — and on zero it says so plainly
     instead of inventing a loss. Deliberately not the live theme's design,
     which latches an "expired" flag in localStorage and then shows "Time's up!"
     to every returning visitor forever. */
  var holdEl = root.querySelector('[data-cd-hold]');
  var holdTick = null;
  var HOLD_KEY = 'km_cart_hold_until';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { v === null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} }

  function holdPaint() {
    if (!holdEl) return;
    var until = parseInt(lsGet(HOLD_KEY), 10) || 0;
    var left = Math.max(0, until - Math.floor(Date.now() / 1000));
    if (!until || left <= 0) {
      holdEl.textContent = holdEl.getAttribute('data-done') || '';
      holdEl.classList.remove('is-live');
      if (holdTick) { clearInterval(holdTick); holdTick = null; }
      return;
    }
    var m = Math.floor(left / 60), s = left % 60;
    holdEl.classList.add('is-live');
    var stamp = m + ':' + (s < 10 ? '0' : '') + s;
    holdEl.textContent = (holdEl.getAttribute('data-live') || '[time]').replace('[time]', stamp);
  }

  function holdSync(cart) {
    if (!holdEl) return;
    holdEl.hidden = !cart.item_count;
    if (!cart.item_count) { lsSet(HOLD_KEY, null); if (holdTick) { clearInterval(holdTick); holdTick = null; } return; }
    if (!lsGet(HOLD_KEY)) {
      var mins = parseInt(holdEl.getAttribute('data-minutes'), 10) || 10;
      lsSet(HOLD_KEY, String(Math.floor(Date.now() / 1000) + mins * 60));
    }
    holdPaint();
    if (!holdTick) holdTick = setInterval(holdPaint, 1000);
  }

  /* ── Discount code ────────────────────────────────────────────────────────
     GET /discount/<CODE> is the only mechanism that moves the real Liquid cart
     without a reload: it sets the shop's discount cookie and a following
     /cart.js reflects it. Two things it does NOT give us, which shape the UI:

     1. No error. Invalid, expired, minimum-not-met and non-combinable all
        return the same 302 -> 200. Validity is inferred by diffing the applied
        codes before and after, so the failure copy says the code did not apply
        to THIS order rather than claiming it does not exist.
     2. No removal endpoint. Chips are therefore rendered from the cart after a
        round trip, never optimistically — the UI can never claim a state the
        cart does not actually have. */
  var promoForm = root.querySelector('[data-cd-promo-form]');
  var promoInput = root.querySelector('[data-cd-promo-input]');
  var promoMsg = root.querySelector('[data-cd-promo-msg]');
  var promoChips = root.querySelector('[data-cd-chips]');
  var promoBusy = false;

  /* Both kinds, merged by title. A BOGO shows up once per affected line, so
     without the merge the same offer is listed two or three times. */
  function appliedCodes(cart) {
    var seen = {}, out = [];
    function add(title, amount) {
      if (!title) return;
      if (seen[title] === undefined) { seen[title] = out.length; out.push({ title: title, amount: amount || 0 }); }
      else { out[seen[title]].amount += (amount || 0); }
    }
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      add(d.title, d.total_allocated_amount);
    });
    (cart.items || []).forEach(function (it) {
      lineDiscounts(it).forEach(function (d) { add(d.title, d.amount); });
    });
    return out;
  }

  /* cart.discount_codes is Shopify's own verdict on a typed code and the whole
     reason the old check was wrong. It used to infer success by diffing offer
     titles before and after, so a code that Shopify accepted but did not apply
     - because an automatic offer already held those lines - looked exactly like
     a code that does not exist, and the shopper was told theirs was invalid
     when it was not.

     What this field cannot do is separate a fake code from a real one that
     simply did not apply: both are recorded with applicable false. So the
     message says what is true of both - that it was not applied - and names
     what IS on the bag, rather than inventing a reason. */
  function codeState(cart, code) {
    var list = cart.discount_codes || [];
    var want = String(code || '').toUpperCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].code || '').toUpperCase() === want) {
        return list[i].applicable ? 'applied' : 'inactive';
      }
    }
    return 'absent';
  }

  /* Offers already on the bag on the previous render, kept because it is what
     tells a chip that has just arrived from one that has been sitting there.
     The banner it used to feed is gone: it appeared under the tools row and
     pushed the subtotal and the checkout button down for six seconds, and the
     chip beside the subtotal already says which offer is on the bag -
     permanently, and without moving anything. */
  var knownOffers = null;

  function renderChips(cart) {
    if (!promoChips) return;
    var codes = appliedCodes(cart);
    var titles = codes.map(function (c) { return c.title; });
    var fresh = knownOffers
      ? titles.filter(function (x) { return knownOffers.indexOf(x) === -1; })
      : [];

    /* innerHTML rebuilds every chip on every render, so the entrance animation
       used to replay on any cart change at all - a quantity nudge popped every
       offer as though it had just arrived. Only genuinely new ones animate. */
    promoChips.innerHTML = codes.map(function (c) {
      var isNew = fresh.indexOf(c.title) > -1;
      return '<span class="cd-chip' + (isNew ? ' cd-chip--new' : '') + '">' +
             '<span class="cd-chip__label">' + escapeHtml(c.title) + '</span>' +
             (c.amount ? '<span class="cd-chip__amt">−' + escapeHtml(money(c.amount)) + '</span>' : '') +
             '</span>';
    }).join('');
    promoChips.hidden = !codes.length;

    knownOffers = titles;
  }

  function setPromoMsg(text, bad) {
    if (!promoMsg) return;
    promoMsg.textContent = text || '';
    promoMsg.classList.toggle('is-bad', !!bad);
  }

  if (promoForm) {
    promoForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (promoBusy) return;
      var code = (promoInput.value || '').trim();
      if (!code) { promoInput.focus(); return; }

      promoBusy = true;
      promoForm.classList.add('is-busy');
      setPromoMsg('');
      setLoading(true);

      fetchCart().then(function () {
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { return fetchCart(); })
          .then(function (after) {
            /* Solely Shopify's verdict on THIS code. The old fallback also
               accepted "the bag has more offers than it did", which credits the
               typed code with an arrival that had nothing to do with it -
               Shopify re-evaluates every code it is still holding on each
               apply, so a previously stored one becoming applicable would have
               cleared the field and reported a wrong code as accepted. When
               that happens now the code is correctly refused and the offer that
               really did arrive is announced by the new-offer cue instead. */
            var landed = codeState(after, code) === 'applied';
            render(after);

            if (landed) {
              promoInput.value = '';
              promoForm.classList.add('is-applied');
              setTimeout(function () { promoForm.classList.remove('is-applied'); }, 900);
              return;
            }

            /* Name what is holding the bag rather than guess why the code did
               not take. "Not applied, and here is what you already have" is
               true whether the code was fake or simply could not combine. */
            var blocking = appliedCodes(after)[0];
            setPromoMsg(blocking
              ? code.toUpperCase() + ' was not applied — ' + blocking.title + ' is already on your bag.'
              : code.toUpperCase() + ' does not apply to this order.', true);
          });
      }).catch(function () {
        setPromoMsg('We couldn’t check that code. Please try again.', true);
      }).then(function () {
        promoBusy = false;
        promoForm.classList.remove('is-busy');
        setLoading(false);
      });
    });
  }

  /* ── Cart add-on ──────────────────────────────────────────────────────────
     Toggling on adds the configured variant; toggling off removes that line.

     Two rules keep this honest. The switch is set from the cart on every
     render, never from a remembered flag — the personalizer's cart-sync embed
     re-renders the drawer after its own mutations and would overwrite anything
     held in JS. And removal targets item.key, not the variant id: a shopper who
     also bought the add-on product normally has two lines with the same variant,
     and only the toggled one carries _addon. */
  /* ── Upsell position dots ─────────────────────────────────────────────────
     The row slides and its scrollbar is hidden, so nothing said so. One dot
     per card, the current one lit.

     Position is taken from the scroll fraction across the whole range rather
     than from "which card is leftmost". With two and a half cards on screen
     the last cards can never BE leftmost, so that reading would have left the
     final dots permanently dark - the row would look like it ends before it
     does. Mapping the fraction over the dots instead means the first dot is
     the start and the last dot is the end, which is what someone reads them
     as.

     Hidden outright when the whole row already fits: dots that cannot move
     are decoration, and they would say there is more when there is not. */
  var upRow = root.querySelector('[data-cd-upsell-row]');
  var upDots = root.querySelector('[data-cd-upsell-dots]');
  var upTick = 0;

  function upsellDots() {
    if (!upRow || !upDots) return;
    var cards = upRow.querySelectorAll('[data-cd-upsell-item]').length;
    var max = upRow.scrollWidth - upRow.clientWidth;

    if (max <= 2 || cards < 2) { upDots.hidden = true; return; }

    if (upDots.childElementCount !== cards) {
      var html = '';
      for (var i = 0; i < cards; i++) html += '<span class="cd-upsell__dot"></span>';
      upDots.innerHTML = html;
    }
    upDots.hidden = false;

    var on = Math.round((upRow.scrollLeft / max) * (cards - 1));
    for (var j = 0; j < upDots.children.length; j++) {
      upDots.children[j].classList.toggle('is-on', j === on);
    }
  }

  if (upRow) {
    /* Passive, and one update per frame: this fires continuously under a
       thumb, and the row must never be the thing that makes the drawer feel
       heavy. */
    upRow.addEventListener('scroll', function () {
      if (upTick) return;
      upTick = requestAnimationFrame(function () { upTick = 0; upsellDots(); });
    }, { passive: true });
    /* The row is laid out from the drawer's width, which changes on rotate. */
    window.addEventListener('resize', upsellDots, { passive: true });
  }

  var addonEl = root.querySelector('[data-cd-addon]');
  var addonInput = root.querySelector('[data-cd-addon-input]');
  var addonVariant = addonEl ? parseInt(addonEl.getAttribute('data-variant'), 10) : 0;
  var addonBusy = false;

  /* "On" means the add-on is in the bag, full stop — matched on the variant
     alone. Requiring properties._addon as well meant that any line which lost
     that property, or was added by some other route, sat in the cart while the
     switch insisted it was off. The shopper can see the line; the switch has to
     agree with the cart, not with how the line got there.

     Removal still prefers the line this switch added, so someone who also
     bought the warranty as a product keeps it when they toggle off. */
  function addonLine(cart) {
    if (!addonVariant) return null;
    var fallback = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id !== addonVariant) continue;
      /* same variant, different thing: the earned one is the rail's, not the
         switch's, and must never be removed as though the shopper bought it */
      if (it.properties && it.properties._km_reward) continue;
      if (it.properties && it.properties._addon) return it;
      if (!fallback) fallback = it;
    }
    return fallback;
  }

  /* ── The earned reward ────────────────────────────────────────────────────
     The rail announces it; this is what actually puts it in the bag.

     A zero-priced variant, never a discount. The automatic Buy 1 Get 1 has
     combinesWith false on all three kinds and Shopify applies one automatic
     discount per order, so a second one would either do nothing or push the
     BOGO off the order the shopper already earned it on.

     Granted off list price like the rail itself, so the BOGO cannot take the
     reward away by lowering what is left to pay. */
  var REWARD_VARIANT = shipEl ? parseInt(shipEl.getAttribute('data-cd-reward-variant'), 10) || 0 : 0;
  /* One source for the number: the last tier on the rail is the thing being
     promised, so it is also what the line claims to have earned. */
  var REWARD_NEED = TIERS.length ? TIERS[TIERS.length - 1].amount : 0;
  var REWARD_LABEL = TIERS.length ? (TIERS[TIERS.length - 1].label || 'Free gift') : 'Free gift';
  var addonFree = root.querySelector('[data-cd-addon-free]');
  var rewardBusy = false;
  var lastCart = null;
  var shipIcon = root.querySelector('[data-cd-ship-icon]');
  var shipIconName = null;

  /* A bag holding nothing but the reward is not an order. It can only happen
     by hand - the rail never grants it unless the cart has earned it, and
     takes it back the moment the cart drops - but /cart/add.js is a public
     endpoint and the variant id is in the page, so the checkout path has to
     refuse it rather than trust that nobody will try.

     Synchronous on purpose: this runs inside a click that is about to
     navigate, and there is no time to ask the server first. render() keeps
     lastCart current, and if it is somehow stale the worst case is a $0 order
     we would have let through anyway. */
  function rewardOnly(cart) {
    if (!REWARD_VARIANT || !cart || !cart.items || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id !== REWARD_VARIANT) return false;
    }
    return true;
  }

  function blockRewardOnly(e) {
    if (!rewardOnly(lastCart)) return false;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    showError('Your bag only has the free warranty in it. Add the piece it covers to check out.');
    /* And take it back out, so the bag matches what the rail says again. */
    if (!rewardBusy && lastCart.items[0]) {
      rewardBusy = true;
      changeLine(lastCart.items[0].key, 0)
        .then(function () { return refresh(); })
        .catch(function () {})
        .then(function () { rewardBusy = false; });
    }
    return true;
  }

  /* The cart page has its own checkout button, outside this drawer. Capture
     phase, so it runs before the form's own submit. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], [data-km-checkout]');
    if (btn) blockRewardOnly(e);
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.getAttribute('action') && e.target.getAttribute('action').indexOf('/cart') === 0) {
      blockRewardOnly(e);
    }
  }, true);

  /* Identified by its property, not by its variant.
     The reward IS the paid warranty now - the same variant the add-on switch
     sells - because a $0 product sitting in a public catalogue is farmable and
     was farmed: five, seven and one of them, ordered for nothing, on 25 Oct.
     Nothing free exists any more. The line goes in at its real $6.95 and the
     app's cart-transform zeroes it server-side, but only once the cart has
     earned it, so a request that adds it directly just pays.
     _km_reward is what the function reads, so it is also what tells these two
     lines apart here. */
  function rewardLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties;
      if (p && p._km_reward) return cart.items[i];
    }
    return null;
  }

  function syncReward(cart, earned) {
    if (!REWARD_VARIANT || !REWARD_NEED || rewardBusy) return;
    var have = rewardLine(cart);
    if (!!have === !!earned) return;

    rewardBusy = true;
    var work;

    if (earned) {
      /* Swap, never stack. Someone who already paid for the add-on must not
         be left holding two of it the moment their cart qualifies - and the
         paid line goes first, so a failure halfway leaves them with the one
         they chose rather than with nothing. */
      var paid = addonLine(cart);
      work = (paid ? changeLine(paid.key, 0) : Promise.resolve()).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          /* The threshold travels with the line, in cents, so the function
             checks the same number the rail showed rather than a copy of it
             that can drift. Quantity is pinned to one; the function refuses to
             free more than one anyway. */
          body: JSON.stringify({ items: [{
            id: REWARD_VARIANT,
            quantity: 1,
            properties: {
              _km_reward: JSON.stringify({ kind: 'spend', need: REWARD_NEED }),
              _km_gift_label: REWARD_LABEL
            }
          }] })
        }).then(function (r) { if (!r.ok) throw new Error('reward_add_' + r.status); });
      });
    } else {
      /* Dropped back below the tier. Leaving it would ship a paid add-on for
         nothing, or charge for one the bag was told was free. */
      work = changeLine(have.key, 0);
    }

    setLoading(true);
    work.then(function () { return refresh(); })
        .catch(function () { /* the next cart change tries again */ })
        .then(function () { rewardBusy = false; setLoading(false); });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('reward_change_' + r.status); });
  }

  function renderAddon(cart) {
    if (!addonEl || !addonInput) return;
    addonEl.hidden = !cart.item_count;

    /* Free beats paid: the row describes the line that is actually in the bag.
       The control goes inert because the rail owns it now - a shopper who
       switched it off would be discarding something the cart qualifies for,
       with no way to ask for it back. */
    var free = !!rewardLine(cart);
    addonEl.classList.toggle('is-free', free);
    if (addonFree) addonFree.hidden = !free;
    addonInput.disabled = free;

    if (addonBusy) return;                       // don't fight the shopper mid-request
    addonInput.checked = free || !!addonLine(cart);
  }

  if (addonInput) {
    addonInput.addEventListener('change', function () {
      if (addonBusy) return;
      addonBusy = true;
      addonEl.classList.remove('is-done');

      var wanted = addonInput.checked;
      fetchCart().then(function (cart) {
        var line = addonLine(cart);
        if (wanted && !line) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: addonVariant, quantity: 1, properties: { _addon: 'cart_toggle' } }] })
          }).then(function (r) { if (!r.ok) throw new Error('addon_add_' + r.status); });
        }
        if (!wanted && line) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          }).then(function (r) { if (!r.ok) throw new Error('addon_remove_' + r.status); });
        }
      }).then(function () {
        addonBusy = false;
        return refresh();
      }).catch(function () {
        addonBusy = false;
        /* Put the switch back where the cart actually is rather than leaving it
           showing a state that never happened. */
        showError('We could not update that. Please try again.');
        return refresh().catch(function () {});
      }).then(function () {
        addonEl.classList.remove('is-working');
        if (addonInput.checked === wanted) {
          /* Confirm only once the cart agrees with the switch. */
          addonEl.classList.add('is-done');
          setTimeout(function () { addonEl.classList.remove('is-done'); }, 700);
        }
      });
    });
  }


  /* ── Discount / note, one panel between them ──────────────────────────────
     Two separate disclosures stacked in the footer read as two more things to
     deal with at the moment of paying. As tabs over a shared panel they read as
     one optional extra: pick a side, or leave both shut. Only one can be open,
     which is also why the height animation is simple — the panel measures the
     incoming pane and travels to it. */
  var tools = root.querySelector('[data-cd-tools]');
  if (tools) {
    var tabs = [].slice.call(tools.querySelectorAll('[data-cd-tab]'));
    var panel = tools.querySelector('[data-cd-tools-panel]');
    var panes = [].slice.call(tools.querySelectorAll('[data-cd-pane]'));
    var openTab = null;

    function paneFor(name) { return panes.filter(function (p) { return p.getAttribute('data-cd-pane') === name; })[0]; }

    function setTools(name) {
      var closing = (openTab === name);
      openTab = closing ? null : name;

      tabs.forEach(function (b) {
        var on = b.getAttribute('data-cd-tab') === openTab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      panes.forEach(function (p) { p.hidden = p.getAttribute('data-cd-pane') !== openTab; });

      if (!openTab) { panel.style.height = '0px'; tools.classList.remove('is-open'); return; }
      tools.classList.add('is-open');
      var pane = paneFor(openTab);
      panel.style.height = pane.offsetHeight + 'px';
      var field = pane.querySelector('input, textarea');
      if (field) field.focus({ preventScroll: true });
    }

    tabs.forEach(function (b) {
      b.addEventListener('click', function () { setTools(b.getAttribute('data-cd-tab')); });
    });

    /* The height was measured once, at open, and the panel clips what overflows
       it - so anything that arrived afterwards was cut off mid-line: a result
       message longer than the field, or the note textarea after the shopper
       dragged its resize handle. Watching the pane keeps the panel the size of
       whatever is actually in it. */
    if (window.ResizeObserver) {
      var paneWatch = new ResizeObserver(function () {
        if (!openTab) return;
        var pane = paneFor(openTab);
        if (pane) panel.style.height = pane.offsetHeight + 'px';
      });
      panes.forEach(function (p) { paneWatch.observe(p); });
    }
    panel.style.height = '0px';
  }

  /* ── Order note ───────────────────────────────────────────────────────────
     The save was fire-and-forget: no Accept header, no status check, no catch,
     and nothing flushed if the drawer closed inside the debounce window — so a
     note typed and immediately dismissed was silently dropped. It now reports
     what happened and always flushes on close. */
  var note = root.querySelector('[data-cd-note]');
  var noteState = root.querySelector('[data-cd-note-state]');
  var noteTimer = null, noteSent = note ? note.value : '', notePending = false;

  function setNoteState(msg, bad) {
    if (!noteState) return;
    noteState.textContent = msg;
    noteState.classList.toggle('is-bad', !!bad);
  }

  function saveNote() {
    if (!note || note.value === noteSent) return Promise.resolve();
    var value = note.value;
    notePending = true;
    setNoteState('Saving…');
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: value })
    }).then(function (r) {
      if (!r.ok) throw new Error('note_http_' + r.status);
      noteSent = value;
      setNoteState('Saved');
      setTimeout(function () { setNoteState(''); }, 1600);
    }).catch(function () {
      setNoteState('Not saved — we’ll try again when you check out.', true);
    }).then(function () { notePending = false; });
  }

  if (note) {
    note.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 500);
    });
    /* Closing mid-debounce used to lose the note entirely. */
    note.addEventListener('blur', function () { clearTimeout(noteTimer); saveNote(); });
  }

  /* Guarded on is-open. Unguarded, Escape anywhere ran close(), which always
     clears document.body.style.overflow - a lock the collection filter drawer
     also sets. Pressing Escape over that drawer left it open with the page
     scrolling behind it. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  if (CAN_TOP) {
    /* Something outside this file dismissed the popover. Route it back through
       close() so the pending note is flushed and the scroll lock released -
       never leave the storefront unscrollable. topHide() removes .is-open
       first, so this cannot recurse. */
    root.addEventListener('toggle', function (e) {
      if (e.newState === 'closed' && root.classList.contains('is-open')) close();
    });
  }

  // The personalizer's cart-sync embed corrects the cart shortly after
  // mutations (adds free-gift lines, removes orphans). Re-render so those
  // corrections appear without closing and reopening the drawer.
  document.addEventListener('cart:refresh', function () { refresh().catch(function () {}); });

  /* Bootstrap failure is silent on purpose: nothing is open yet, so there is
     nowhere to show a message and no action the shopper was waiting on. */
  refresh().catch(function () {});
})();
